import axios from "axios";
import { apiUrl, supplierApiUrl } from "./apiURL";

const tempObj = {
  data: {
    status: -1,
    message: "Something went wrong. Please try again later.",
  },
};

// 🔹 Default instance (for contacts, etc.)
const apiInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// 🔹 Supplier instance (for supplier-specific calls)
const supplierInstance = axios.create({
  baseURL: supplierApiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// 🔐 Add interceptors to both if needed
const applyTokenInterceptor = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = process.env.REACT_APP_BEARER_TOKEN;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });
};

applyTokenInterceptor(apiInstance);
applyTokenInterceptor(supplierInstance);

// 🔧 Factory for request methods (works for both instances)
const createApiMethods = (instance) => ({
  GetRequest: async (url, params = {}) => {
    try {
      const res = await instance.get(url, { params });
      return res ?? tempObj;
    } catch (err) {
      return { data: { ...tempObj.data, message: err.response?.data?.message || tempObj.data.message } };
    }
  },
  PostRequest: async (url, data) => {
    try {
      const res = await instance.post(url, data);
      return res ?? tempObj;
    } catch (err) {
      return { data: { ...tempObj.data, message: err.response?.data?.message || tempObj.data.message } };
    }
  },
  PutRequest: async (url, data) => {
    try {
      const res = await instance.put(url, data);
      return res ?? tempObj;
    } catch (err) {
      return { data: { ...tempObj.data, message: err.response?.data?.message || tempObj.data.message } };
    }
  },
  PatchRequest: async (url, data) => {
    try {
      const res = await instance.patch(url, data);
      return res ?? tempObj;
    } catch (err) {
      return { data: { ...tempObj.data, message: err.response?.data?.message || tempObj.data.message } };
    }
  },
  DeleteRequest: async (url) => {
    try {
      const res = await instance.delete(url);
      return res ?? tempObj;
    } catch (err) {
      return { data: { ...tempObj.data, message: err.response?.data?.message || tempObj.data.message } };
    }
  },
  PostFileRequest: async (url, data, onProgress) => {
    try {
      const res = await instance.post(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => onProgress && onProgress(progressEvent),
      });
      return res ?? tempObj;
    } catch (err) {
      return { data: { ...tempObj.data, message: err.response?.data?.message || tempObj.data.message } };
    }
  },
});

// 📦 Export both API sets
export const Api = createApiMethods(apiInstance);          // for default API (contacts)
export const SupplierApi = createApiMethods(supplierInstance); // for suppliers

export default apiInstance;